import { reconstructIfScriptNode } from './ts-utils';
import { queryAll } from './utils/utils';
// @ts-ignore
import dialogPolyfill from 'dialog-polyfill';

const cookiesDialog = document.getElementById('cookies-policy-dialog');

// gim.test(document.cookie);

// console.log(cookiesDialog, acceptCookies, document.cookie);

const hasCookieWithVal = (name: string, value: string) => {
  const cookieRegex = new RegExp(`(^| |;)${name}=${value}`);
  return cookieRegex.test(document.cookie);
};

const acceptCookies = hasCookieWithVal('accept_cookies', '1');
const hasVisitedOnce = hasCookieWithVal('has_visited_once', '1');

const setCookie = (name: string, value: string) => {
  document.cookie = `${name}=${value};path=/;max-age=${365 * 24 * 60 * 60}`;
};

const accept = () => {
  // add cookie
  setCookie('accept_cookies', '1');
  // document.cookie = `accept_cookies=1;path=/;max-age=${365 * 24 * 60 * 60}`;

  // add every cookie reliant chunk of code
  queryAll('[data-cookie-reliant]').forEach(element => {
    if (!element.parentElement) {
      return;
    }

    const frag = document.createDocumentFragment();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = element.innerHTML || '';

    /* tslint:disable */
    for (let i = 0; i < tempDiv.childNodes.length; i++) {
      /* tslint:enable */
      const node = tempDiv.childNodes[i].cloneNode(true);
      const formattedNode = reconstructIfScriptNode(node);

      frag.appendChild(formattedNode);
    }
    element.parentElement.insertBefore(frag, element);
  });
};

if (hasVisitedOnce) {
  accept();
}

if (!hasVisitedOnce && cookiesDialog && acceptCookies === false) {
  dialogPolyfill.registerDialog(cookiesDialog);
  cookiesDialog.setAttribute('open', '');
  const form = cookiesDialog.querySelector('form');

  if (form) {
    form.addEventListener('submit', () => {
      accept();
    });
  }
}

document.body.addEventListener('input', () => {
  setCookie('has_visited_once', '1');
});

document.body.addEventListener('click', () => {
  setCookie('has_visited_once', '1');
});



// WEBPACK FOOTER //
// ../work/src/js/cookies.ts